module.exports = __webpack_public_path__ + "img/curiosity-stream-card-header.f431da84.jpg";